<template>
	<div class="educational-background mb30">

		<h3 class="c-title">教育背景
			<a href="javascript:;" class="btn-add" :class="{'disabled':isEditting||!editable}" v-show="status!=0" @click="callOutAddNewItemModal">
				<i class="icon">
					<img src="../../assets/img/common/icon-add-off.png" v-if="isEditting||!editable"/>
					<img src="../../assets/img/common/icon-add.png" v-else="!isEditting&&editable"/>
				</i>
				<span>&nbsp;添加</span>
			</a>
		</h3>

		<!--原始无污染状态-->
		<div class="no-data" v-if="status==0">
			<resume-undone-template blockText="教育背景" :showTitle="false" :editable="editable" @editBtnClick="callOutAddNewItemModal" />
		</div>

		<!--有数据展示状态-->
		<div class="showBox" v-if="status==1">
			<div class="education-item" v-for="(item,index) in itemList" :key="item.id">

				<div class="item-box" v-if="item.show">
					<div class="edcational-info">
						<span class="school-name">{{item.institution}}</span>
						<div class="operation-box">
							<a href="javascript:;" class="operation operation-edit" :class="{'disabled':isEditting||!editable}" @click="editCurrentItem(index,item)">
								<i class="icon icon-pencil">
									<img src="../../assets/img/common/icon-pencil.png" v-if="!isEditting&&editable"/>
									<img src="../../assets/img/common/icon-pencil-off.png" v-else="isEditting||!editable"/>
								</i>
								<span>编辑</span>
							</a>
							<a href="javascript:;" class="operation operation-delete" :class="{'disabled':isEditting||!editable}" @click="deleteResumeEducationalBackground(item.id)">
								<i class="icon icon-pencil">
									<img src="../../assets/img/common/icon-trash-on.png" v-if="!isEditting&&editable"/>
									<img src="../../assets/img/common/icon-trash-off.png" v-else="isEditting||!editable"/>
								</i>
								<span>删除</span>
							</a>
						</div>
					</div>
					<div class="extra-info">
						<span class="major">{{item.studyField}} </span>
						<span class="divider">|</span>
						<span class="diploma">{{item.educationLevelInfo.levelName}}</span>
						<span class="time fr">{{item.dateFromStr}}-<span v-text="item.isCurrent?'至今':item.dateToStr"></span></span>
					</div>
				</div>

				<!--编辑现有项目-->
				<div class="editting" v-if="!item.show">

					<div class="row-24-block">
						<label class="label">学习时间</label>
						<div class="time-range-block cf">
							<el-date-picker type="year" class="mini-input" :clearable="false" prefix-icon="hidethisicon" value-format="yyyy" v-model="tempObj.startYear"></el-date-picker>
							<span class="unit-span">年</span>
							<el-date-picker type="month" format="MM" value-format="MM" class="mini-input" :clearable="false" prefix-icon="hidethisicon" v-model='tempObj.startMonth'></el-date-picker>
							<span class="unit-span">月</span>

							<div class="split-line cf"></div>

							<el-date-picker type="year" class="mini-input" :disabled="tempObj.isNotYet" :clearable="false" prefix-icon="hidethisicon" value-format="yyyy" v-model='tempObj.endYear'></el-date-picker>
							<span class="unit-span">年</span>
							<el-date-picker type="month" format="MM" value-format="MM" class="mini-input" :clearable="false" prefix-icon="hidethisicon" :disabled="tempObj.isNotYet" v-model='tempObj.endMonth'></el-date-picker>
							<span class="unit-span">月</span>

							<div class="not-yet">
								<input type="checkbox" name="keepsecret" v-model='tempObj.isNotYet' />

								<div class="fake-checker">
									<img src="../../assets/img/common/icon-circle-hollow.png" v-if="!tempObj.isNotYet" />
									<img src="../../assets/img/common/icon-circle-tick.png" v-if="tempObj.isNotYet" />
								</div>
								<span>至今</span>
							</div>
						</div>
						<p class="error-tips" v-show="timeError" v-text="timeErrorTips"></p>
					</div>

					<div class="row-24">
						<div class="row-12">
							<label class="label">学校名称</label>
							<input type="text" class="base-input-lg" v-model="tempObj.schoolName">
							<p class="error-tips" v-show="noSchoolName">请输入学校名称</p>
						</div>

						<div class="row-12">
							<label class="label">专业名称</label>
							<input type="text" class="base-input-lg" v-model="tempObj.majorName">
							<p class="error-tips" v-show="noMajorName">请输入专业名称</p>
						</div>
					</div>

					<div class="row-24">
						<div class="row-12">
							<label class="label">学历</label>
							<el-select v-model="tempObj.educationLevelId" placeholder="请选择">
								<el-option v-for="item in eduOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</div>

						<div class="row-12">
							<label class="label">MBA</label>
							<el-select v-model="tempObj.mbaStatus" placeholder="请选择" :disabled="disableMba">
								<el-option v-for="item in mbaOptions" :key="item.label" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>

					<div class="row-24-block no-mb">
						<a href="javascript:;" class="btn-operation btn-save" @click="resumeEducationalBackgroundEditSave">保存</a>
						<a href="javascript:;" class="btn-operation btn-cancel" @click="resumeEducationalBackgroundEditCancel(index)">取消</a>
					</div>

				</div>

			</div>
		</div>

		<!--新增项目的编辑-->
		<div class="editting" v-if="showAddBox">

			<div class="row-24-block">
				<label class="label">学习时间</label>
				<div class="time-range-block cf">
					<el-date-picker type="year" class="mini-input" :clearable="false" prefix-icon="hidethisicon" value-format="yyyy" v-model="tempObj.startYear"></el-date-picker>
					<span class="unit-span">年</span>
					<el-date-picker type="month" format="MM" value-format="MM" class="mini-input" :clearable="false" prefix-icon="hidethisicon" v-model='tempObj.startMonth'></el-date-picker>
					<span class="unit-span">月</span>
					<div class="split-line cf"></div>
					<el-date-picker type="year" class="mini-input" :disabled="tempObj.isNotYet" :clearable="false" prefix-icon="hidethisicon" value-format="yyyy" v-model='tempObj.endYear'></el-date-picker>
					<span class="unit-span">年</span>
					<el-date-picker type="month" format="MM" value-format="MM" class="mini-input" :clearable="false" prefix-icon="hidethisicon" :disabled="tempObj.isNotYet" v-model='tempObj.endMonth'></el-date-picker>
					<span class="unit-span">月</span>

					<div class="not-yet">
						<input type="checkbox" name="keepsecret" v-model='tempObj.isNotYet' />

						<div class="fake-checker" @click="setEndTimeDisabled">
							<img src="../../assets/img/common/icon-circle-hollow.png" v-if="!tempObj.isNotYet" />
							<img src="../../assets/img/common/icon-circle-tick.png" v-if="tempObj.isNotYet" />
						</div>
						<span>至今</span>
					</div>
				</div>
				<p class="error-tips" v-show="timeError" v-text="timeErrorTips"></p>
			</div>

			<div class="row-24">
				<div class="row-12">
					<label class="label">学校名称</label>
					<input type="text" class="base-input-lg" v-model="tempObj.schoolName">
					<p class="error-tips" v-show="noSchoolName">请输入学校名称</p>
				</div>

				<div class="row-12">
					<label class="label">专业名称</label>
					<input type="text" class="base-input-lg" v-model="tempObj.majorName">
					<p class="error-tips" v-show="noMajorName">请输入专业名称</p>
				</div>
			</div>

			<div class="row-24">
				<div class="row-12">
					<label class="label">学历</label>
					<el-select v-model="eduId" placeholder="请选择">
						<el-option v-for="item in eduOptions" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</div>

				<div class="row-12">
					<label class="label">MBA</label>
					<el-select v-model="mba" placeholder="请选择" :disabled="disableMba">
						<el-option v-for="item in mbaOptions" :key="item.label" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>

			<div class="row-24-block no-mb">
				<a href="javascript:;" class="btn-operation btn-save" @click="resumeEducationalBackgroundAddSave">保存</a>
				<a href="javascript:;" class="btn-operation btn-cancel" @click="resumeEducationalBackgroundAddCancel">取消</a>
			</div>
		</div>

	</div>
</template>

<script>
	import ResumeUndoneTemplate from '@/components/EditResume/ResumeUndoneTemplate.vue'
	import { httpGetEduLevel } from '@/api/common'; //获取学历等级
	import { httpResumeEducationalBackgroundGet, httpResumeEducationalBackgroundAdd, httpResumeEducationalBackgroundDelete, httpResumeEducationalBackgroundEdit } from '@/api/resume'

	export default {
		name: 'ResumeEducationalBackground',
		components: {
			ResumeUndoneTemplate
		},
		props: {
			resumeId: {
				type: Number,
				required: true
			},
			editable: {
				type: Boolean,
				required: true
			}
		},
		data() {
			return {
				status: 1, //0-初始状态，1-污染状态
				eduOptions: [],
				eduId: 1,
				mbaOptions: [{
					value: 0,
					label: '无',
				}, {
					value: 1,
					label: 'MBA',
				}, {
					value: 2,
					label: 'EMBA',
				}],
				mba: 0,
				disableMba: false,
				showAddBox: false, //指示是否纯粹新增选项
				isEditting: false, //指示是否当前是否正在编辑
				itemList: [],
				tempObj: {
					id: 0,
					startYear: '',
					startMonth: '',
					endYear: '',
					endMonth: '',
					isNotYet: false,
					educationLevelId: 1,
					schoolName: '',
					majorName: '',
					mbaStatus: 0,
				},
				//错误提示
				timeError: false,
				timeErrorTips: '',
				noSchoolName: false,
				noMajorName: false,

			}
		},
		mounted() {
			setTimeout(() => this.getResumeEducationalBackground(), 50);
		},
		methods: {

			//打开新增语言能力功能窗
			callOutAddNewItemModal() {
				if(this.isEditting || !this.editable) return;
				this.shouldIGetEduOptions();
				this.isEditting = true;
				this.showAddBox = true;
				this.status = 1;
				this.$emit('set-edit-status',1);
				this.resetTempObj();
			},

			//保存新增的教育信息等级
			resumeEducationalBackgroundAddSave() {
				const oData = this.buildData(); //发送的数据对象
				const canISubmit = this.beforeSave();
				if(!canISubmit) return;

				httpResumeEducationalBackgroundAdd(oData).then(r => {
					console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '新增成功',
							duration: 1200,
						})
						this.getResumeEducationalBackground();
						this.status = 1;
						this.showAddBox = false;
						this.isEditting = false;
						this.$emit('set-edit-status',2);
					} else {
						console.log(r);
						this.$message.error('保存失败，请稍后再试。');
					}

				}).catch(err => {
					console.log(err);
					this.$message.error('保存失败，请稍后再试。');
				});
			},

			//判断保存中各值是否符合要求
			beforeSave() {
				if(!this.tempObj.startYear || !this.tempObj.startMonth) {
					this.timeError = true;
					this.timeErrorTips = '请完善就读时间'
					return false;
				} else {
					this.timeError = false;
				}

				if((!this.tempObj.endYear || !this.tempObj.endMonth) && !this.tempObj.isNotYet) {
					this.timeError = true;
					this.timeErrorTips = '请完善就读时间'
					return false;
				} else {
					this.timeError = false;
				}

				if(this.tempObj.endYear) {
					if(this.tempObj.endYear < this.tempObj.startYear) {
						this.timeError = true;
						this.timeErrorTips = '截至时间必须大于起始时间'
						return false;
					} else {
						this.timeError = false;
					}
				}

				if(!this.tempObj.schoolName) {
					this.noSchoolName = true;
					return false;
				} else {
					this.noSchoolName = false;
				}

				if(!this.tempObj.majorName) {
					this.noMajorName = true;
					return false;
				} else {
					this.noMajorName = false;
				}

				return true;
			},

			buildData() {
				let dateTo;
				let cur_date;
				let d = new Date();
				let year = d.getFullYear();
				let month = d.getMonth() + 1;

				dateTo = year + "-" + month;
				cur_date = year + "-" + month;

				if(this.tempObj.isNotYet) {
					this.tempObj.endYear = year.toString();
					this.tempObj.endMonth = month.toString();
				}

				let oData = {
					resumeId: this.resumeId,
					id: this.tempObj.id,
					dateFrom: this.tempObj.startYear.toString() + "-" + this.tempObj.startMonth.toString(),
					dateTo: (this.tempObj.endYear + "-" + this.tempObj.endMonth) || cur_date,
					isCurrent: this.tempObj.isNotYet,
					institution: this.tempObj.schoolName,
					field: this.tempObj.majorName,
					educationLevelId: this.eduId,
					mbaStatus: this.mba,
				};

				return oData;
			},

			//重置容器避免污染
			resetTempObj() {
				this.tempObj = {
					id: 0,
					startYear: '',
					startMonth: '',
					endYear: '',
					endMonth: '',
					isNotYet: false,
					educationLevelId: 1,
					schoolName: '',
					majorName: '',
					mbaStatus: 0,
				}
			},

			//取消新增语言选项
			resumeEducationalBackgroundAddCancel() {
				this.showAddBox = false;
				this.isEditting = false;
				if(this.itemList.length == 0) {
					this.status = 0;
				}
				this.$emit('set-edit-status',2);
			},

			//删除现有教育经历
			deleteResumeEducationalBackground(id) {
				if(this.isEditting||!this.editable) return;
				let oData = {
					ids: [id],
				}
				httpResumeEducationalBackgroundDelete(oData).then(r => {
					console.log(r);
					if(r.success) {
						let vm = this;
						this.$message({
							type: 'success',
							message: '删除成功',
							duration: 500,
							onClose: function() {
								vm.getResumeEducationalBackground();
							}
						});
						this.showAddBox = false;
						this.isEditting = false;
					} else {
						this.$message.error("删除失败，请稍后再试");
					}

				}).catch(err => {
					this.$message.error("删除失败，请稍后再试");
				});
			},

			//点击编辑现有选项按钮----需要吧item的数据想办法改编成tempObj的形式，让他临时作为数据源用
			editCurrentItem(index, item) {
				if(this.isEditting || !this.editable) return;
				let temp = JSON.parse(JSON.stringify(item));

				this.tempObj.id = temp.id;
				this.tempObj.startYear = temp.dateFromStr.split(".")[0];
				this.tempObj.startMonth = temp.dateFromStr.split(".")[1];
				this.tempObj.endYear = temp.dateToStr.split(".")[0];
				this.tempObj.endMonth = temp.dateToStr.split(".")[1];
				this.tempObj.isNotYet = temp.isCurrent;
				this.tempObj.educationLevelId = temp.educationLevelId;
				this.tempObj.schoolName = temp.institution;
				this.tempObj.majorName = temp.studyField;
				this.tempObj.mbaStatus = temp.mbaStatus;

				this.itemList[index].show = false;
				this.isEditting = true;
				this.shouldIGetEduOptions();
				this.$emit('set-edit-status',1);
			},

			//保存现有选项 的编辑操作
			resumeEducationalBackgroundEditSave() {
				const oData = this.buildData(); //发送的数据对象
				const canISubmit = this.beforeSave();
				if(!canISubmit) return;

				httpResumeEducationalBackgroundEdit(oData).then(r => {
					//console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '修改成功',
							duration: 1200,
						})
						this.getResumeEducationalBackground();
						this.status = 1;
						this.showAddBox = false;
						this.isEditting = false;
						this.$emit('set-edit-status',2);
					} else {
						console.log(r);
						this.$message.error('保存编辑失败，请您稍后再试！');
					}

				}).catch(err => {
					console.log(err);
					this.$message.error('保存编辑失败，请您稍后再试！');
				});
			},

			//取消对现有项的编辑操作
			resumeEducationalBackgroundEditCancel(index) {
				this.isEditting = false;
				this.itemList[index].show = true;
				this.$emit('set-edit-status',2);
			},

			//判断是否应该获取一次学历等级选项
			shouldIGetEduOptions() {
				if(!this.eduOptions.length) {
					this.getEduOptions();
				}
			},

			//编辑项目时选择至今
			setEndTimeDisabled() {
				if(this.tempObj.isNotYet) {
					this.tempObj.isNotYet = false;
				} else {
					this.tempObj.isNotYet = true;
					let d = new Date();
					let year = d.getFullYear();
					let month = d.getMonth() + 1;
					this.tempObj.endYear = year.toString();
					this.tempObj.endMonth = month.toString();
				}
			},

			//获取教育经历信息
			getResumeEducationalBackground() {
				let prama = this.resumeId.toString();
				httpResumeEducationalBackgroundGet(prama).then(r => {
					//console.log(r);
					if(r.success) {
						this.itemList = r.data;
						this.itemList.forEach(item => {
							this.$set(item, 'show', true);
							item.educationLevelId = Number(item.educationLevelId);
							item.mbaStatus = Number(item.mbaStatus);
						});
						if(this.itemList.length == 0) {
							this.status = 0;
						}
					} else {
						this.$notify({
							title: '警告',
							message: '获取简历教育经历失败',
							type: 'warning'
						});
					}

				}).catch(err => {
					console.log(error);
					this.$notify({
						title: '警告',
						message: '获取简历教育经历失败',
						type: 'warning'
					});
				});

			},

			//获取学历选项
			getEduOptions() {
				httpGetEduLevel({}).then(r => {
					if(r.success) {
						this.eduOptions = r.data;
						//this.setEduLevel();
					} else {
						this.$notify({
							title: '警告',
							message: '获取学历等级失败',
							type: 'warning'
						});
					}
				}).catch(error => {
					this.$notify({
						title: '警告',
						message: '获取学历等级失败',
						type: 'warning'
					});
				});
			}

		}, //methods结束
		watch: {
			'eduId': function(val, oldVal) {
				val > 2 ? this.disableMba = true : this.disableMba = false;
			},
			'tempObj.educationLevelId': function(val, oldVal) {
				val > 2 ? this.disableMba = true : this.disableMba = false;
			},
		}
	}
</script>

<style scoped lang='less'>
	@import url("../../assets/css/editResume.less");
	.education-item {
		padding-bottom: 30px;
		margin-bottom: 30px;
		border-bottom: 1px solid #eee;
		.edcational-info {
			margin-bottom: 19px;
		}
	}
	
	.item-box {
		position: relative;
		margin-bottom: 14px;
		color: #333;
		.school-name {
			font-size: 16px;
			font-weight: bold;
		}
		.time {
			color: #999;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/EditResume/ResumeEducationalBackground.vue